/** @unocss-include */

export interface NavItem {
  icon: string;
  label: string;
  route: string;
  active: string;
  enabled?: boolean;
}

export function useNavItems() {
  const features = useFeature(['support', 'stripe_payment_method', 'account_pack_subscription']);

  const page = usePage();
  const { t } = useI18n();

  function active(name: string) {
    return computed(() => {
      // eslint-disable-next-line ts/no-unused-expressions
      page.url;

      return route().current(name);
    }).value;
  }

  const items = computed<NavItem[]>(() => [
    { icon: 'i-celeste-global-line', label: t('home.title'), route: 'index', active: 'index' },
    { icon: 'i-celeste-settings-3-line', label: t('general.title'), route: 'account.index', active: 'account' },
    { icon: 'i-celeste-shield-keyhole-line', label: t('security.title'), route: 'security.index', active: 'security' },
    { icon: 'i-celeste-wallet-line', label: t('payment-methods.title'), route: 'payment-methods.index', active: 'payment-methods', enabled: features.stripe_payment_method.active },
    { icon: 'i-celeste-loop-left-line', label: t('account-pack-subscription.title'), route: 'account-pack-subscription.index', active: 'account-pack-subscription', enabled: features.account_pack_subscription.active },
    { icon: 'i-celeste-headphone-line', label: t('support.title'), route: 'support.index', active: 'support', enabled: features.support.active },
  ].filter(item => 'enabled' in item ? item.enabled : true));

  return {
    items,
    active,
  };
}
